import React from 'react'

function LockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 118 118"
      fill="none"
    >
      <path
        d="M59 81.1248V71.2915"
        stroke="#5B5F66"
        strokeWidth="8.5"
        strokeLinecap="round"
      />
      <path
        d="M20.9832 92.6531C22.0889 100.865 28.8908 107.299 37.1682 107.679C44.1332 108 51.2084 108.167 58.9998 108.167C66.7913 108.167 73.8664 108 80.8313 107.679C89.109 107.299 95.9107 100.865 97.0165 92.6531C97.7383 87.2939 98.3332 81.8015 98.3332 76.2083C98.3332 70.6151 97.7383 65.1227 97.0165 59.7636C95.9107 51.5513 89.109 45.1177 80.8313 44.7372C73.8664 44.417 66.7913 44.25 58.9998 44.25C51.2084 44.25 44.1332 44.417 37.1682 44.7372C28.8908 45.1177 22.0889 51.5513 20.9832 59.7636C20.2616 65.1227 19.6665 70.6151 19.6665 76.2083C19.6665 81.8015 20.2616 87.2939 20.9832 92.6531Z"
        stroke="#5B5F66"
        strokeWidth="8.5"
      />
      <path
        d="M36.875 44.2502V31.9585C36.875 19.7392 46.7807 9.8335 59 9.8335C71.2194 9.8335 81.125 19.7392 81.125 31.9585V44.2502"
        stroke="#5B5F66"
        strokeWidth="8.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LockIcon
